interface CartAddress {
  addressId: string;
  attnTo?: string;
  city?: string;
  contactInfo?: {
    name: string;
    email: string;
    phone: string;
  };
  country?: string;
  name?: string;
  state?: string;
  street1?: string;
  street2?: string | null;
  tddd?: string | null;
  zipCode?: string | null;
  zipExtraFour?: string | null;
}

interface CartPrice {
  currency: string;
  displayValue: string;
  type: string;
  value: number;
}

interface CartItem {
  billToAddress?: CartAddress;
  billToOrganizationId?: string;
  cartId: string;
  code?: number;
  healthcareLicense: {
    expirationDate?: string;
    licenseNumber?: string;
    licenseType?: string;
    name?: string;
    state?: string;
  };
  internalCartLineItemId: string;
  materialMasterId?: number;
  priceSnapshotId: string | null;
  productId: number;
  productPrice?: {
    currencyCode: string;
    discountAmount: number;
    discountAmountFormatted: string;
    finalPrice: number;
    finalPriceFormatted: string;
    listPrice: number;
    listPriceFormatted: string;
    productId: string;
  };
  purchaseOrderNumber: string;
  quantity: number;
  shipToAddress: CartAddress;
  shipToOrganizationId: string;
  unitContractPrice?: CartPrice;
  unitListPrice?: CartPrice;
  unitType?: string | null;
}

export interface CommerceState {
  cartData: {
    cartId: string;
    cartLineItems: CartItem[];
  };
  orderableProducts: {
    code: number;
    materialMasterId: number;
  }[];
  userData: {
    addresses: {
      id: number;
      organizationId: number;
      state: string;
    }[];
    licenses: {
      expiration: string | null;
      firstName: string;
      lastName: string;
      licenseType: string;
      name: string | null;
      number: string;
      state: string;
    }[];
  };
}
